import React from 'react';
import { Card, Typography, Timeline, Divider, Row, Col } from 'antd';
import { RocketOutlined, ClockCircleOutlined, SafetyOutlined, SyncOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

export const AboutApp = ({ setLoading, showMessage }) => {
    return (
        <div style={{ padding: 24 }}>
            <Card>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Title level={2}>سامانه مدیریت رزرواسیون اتاق در حسینیه نجف آبادیها - مشهد مقدس</Title>
                        <Paragraph>
                            یک سامانه جامع و هوشمند برای مدیریت کامل فرآیندهای رزرواسیون، پذیرش زائر و خدمات حسینه ها در مشهد مقدس
                        </Paragraph>
                    </Col>
                    
                    <Col xs={24} md={12}>
                        <Title level={4}>ویژگی‌های کلیدی</Title>
                        <Timeline
                            items={[
                                {
                                    color: 'green',
                                    dot: <RocketOutlined />,
                                    children: 'مدیریت هوشمند فرآیند ثبت نام و رزرواسیون اتاق',
                                },
                                {
                                    color: 'blue',
                                    dot: <SyncOutlined />,
                                    children: 'مدیریت هوشمند رزرواسیون غذا',
                                },
                                {
                                    color: 'red',
                                    dot: <SafetyOutlined />,
                                    children: 'امنیت بالا',
                                },
                                {
                                    color: 'orange',
                                    dot: <ClockCircleOutlined />,
                                    children: 'گزارش‌گیری بلادرنگ',
                                },
                            ]}
                        />
                    </Col>
                    
                    <Col xs={24} md={12}>
                        <Title level={4}>مزایا</Title>
                        <Paragraph>
                            • کاهش خطای انسانی<br />
                            • افزایش رضایت زائرین محترم<br />
                            • مدیریت یکپارچه عملیات<br />
                            • کاهش هزینه‌های عملیاتی<br />
                            • گزارش‌گیری دقیق و آنی<br />
                            • انجام کاملا آنلاین رزرو اتاق ، رزرو غذا و پارکینگ زائرین محترم<br />
                        </Paragraph>
                    </Col>
                    
                    <Col span={24}>
                        <Divider />
                        <Title level={4}>نسخه برنامه</Title>
                        <Row gutter={[16, 16]}>
                            <Col span={8}>
                                <Text strong>نسخه نرم‌افزار:</Text>
                                <Text> 404.4.۱</Text>
                            </Col>
                            <Col span={8}>
                                <Text strong>تاریخ انتشار:</Text>
                                <Text> 1404/06/26</Text>
                            </Col>
                            <Col span={8}>
                                <Text strong>تعداد کاربران:</Text>
                                <Text> 3000+</Text>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
        </div>
    );
};